var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"dui-toggle-button",class:[
    _vm.vm.colorClass,
    {
      'readonly': _vm.readonly,
      'toggled': _vm.isToggled,
    } ],attrs:{"title":_vm.title},on:{"click":_vm.toggle}},[_c('span',{staticClass:"toggle"}),_vm._v(" "),(!!_vm.label)?_c('span',{staticClass:"toggle-label"},[_vm._v(_vm._s(_vm.label))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }